import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { AuthProvider } from "./context/AuthContext";
// import { KnowledgeBaseProvider } from "./context/KnowledgeBaseContext";
// import { AgentProvider } from "./context/AgentContext";
import { OnboardingProvider } from "./context/OnboardingContext";
import { GoogleOAuthProvider } from "@react-oauth/google";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <GoogleOAuthProvider
    clientId={
      "107189977981-u6ph9pkdjnate5ck8iusid73n8v24crg.apps.googleusercontent.com"
    }
  >
    <AuthProvider>
      <OnboardingProvider>
        {/* <KnowledgeBaseProvider> */}
        {/* <AgentProvider> */}
        <App />
        {/* </AgentProvider> */}
        {/* </KnowledgeBaseProvider> */}
      </OnboardingProvider>
    </AuthProvider>
  </GoogleOAuthProvider>
);
